export default {
  setDigitalMarketing(state, payload) {
    state.digitalMarketing =payload;
  },
  createDigitalMarketing(state,payload){
    state.digitalMarketing.push(payload);
  }
};
